export enum GeneratorCountryZoneModalType {
  DeleteItem = 'DeleteItem',
  SaveItem = 'SaveItem',
  None = 'None',
}
